import { render, staticRenderFns } from "./EmailStep.vue?vue&type=template&id=71ad83d4&scoped=true&"
import script from "./EmailStep.vue?vue&type=script&lang=js&"
export * from "./EmailStep.vue?vue&type=script&lang=js&"
import style0 from "./EmailStep.vue?vue&type=style&index=0&id=71ad83d4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ad83d4",
  null
  
)

export default component.exports